import { useLista } from "../../components/hooks/useLista"
import { APIS } from "../../config/apis"
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { standardRequest } from "../../utils/requests"
import { imageBase } from "./components/archivosFirma"
import { APPCONFIG } from '../../app.config'
import { isEmptyString } from "../../utils/validator"

export const useGetListaCell = () => {
    const [, getRowLista, listasReady] = useLista({
        listas: ['EstadoFirma', 'TipoFirma'],
        onLoaded: (listas, isSuccess, error) => {
            if (!isSuccess) ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error)
        },
        memo: {
          key: 'FirmaDigitalListas',
          timeout: 0
        },
    })

    return (lista) => ({ value }) => {
        if (!listasReady) return ''
        else return (getRowLista(lista, value) ?? {}).nombre ?? ''
    }
}

export const getDownloadCell = (onDownload) => ({ row }) => (
    <div className="action">
        <div onClick={() => onDownload(row.original)} className="link">
            <span className="material-symbols-outlined" title="Descargar">download</span>
        </div>
    </div>
)

export const scannerFirmar = (identificadorFirmaDigital, imagenFirmaDigital, file64) => new Promise((resolve, reject) => {
    // password: Lanus2022
    const pedido = {
        Orden: 5, //"Firmar"
        Id: 0,
        Texto: `pdf|${identificadorFirmaDigital}|${APPCONFIG.GENERAL.IDENTIFICADOR_AC}`,
        Datos: !isEmptyString(imagenFirmaDigital) ? [file64, imagenFirmaDigital] : [file64],
    }

    if (!APPCONFIG.GENERAL.DIGITAL_SIGNATURE_ENABLED) {
        resolve(file64);
        return;
    }

    const socket = new WebSocket("ws://localhost:6464/scanner") // cambiar por env var?

    socket.onopen = () => { socket.send(JSON.stringify(pedido)) }
    socket.onmessage = (e) => {
        const response = JSON.parse(e.data)
        if (!response.Datos) reject(response.Texto)
        else resolve(response.Datos[0])
        socket.close()
    }
    socket.onerror = (e) => {
        alert("Error en la conexión con el componente local, no se puede escanear, modificar documentos ni firmarlos. verifique que el mismo esté funcionando o contacte al soporte técnico " + e.data);
        reject(e.data)
    }
})

export const firmarArchivos = async (identificadorFirmaDigital, imagenFirmaDigital, firmas, observacion) => {
    const files = await Promise.all(firmas.map(async ({ id }) => {
        const { file64 } = await standardRequest(REQUEST_METHOD.GET, `${APIS.URLS.FIRMA_DIGITAL}/${id}/last-file`)
        return { id, file64 }
    }))

    if (!isEmptyString(imagenFirmaDigital)) {
        const aImagenFirmaDigital = imagenFirmaDigital.split(',');
        imagenFirmaDigital = aImagenFirmaDigital[aImagenFirmaDigital.length - 1]; //me quedo con la ultima parte que es dato puro
    }

    const signedFiles = []
    const errors = []
    for (let i = 0; i < files.length; i++) { // uno por uno, porque el scanner no acepta pedidos concurrentes
        const { id, file64 } = files[i]
        signedFiles.push({ id, file64: await scannerFirmar(identificadorFirmaDigital, imagenFirmaDigital, file64).catch(errors.push) })
        //signedFiles.push({ id, file64 })
    }

    await Promise.all(signedFiles.map(({ id, file64 }) => standardRequest(
        REQUEST_METHOD.PUT,
        `${APIS.URLS.FIRMA_DIGITAL}/firma/${id}`,
        { observacion, file64 },
    ))) // si rompe uno, los que quedan a veces no se terminan de firmar

    if (errors.length > 0)
        throw errors[0]
}
